@let isAssistantOrHigher = isAssistantOrHigher$ | async;
<form [formGroup]="siteFormGroup" appScrollToInvalidControlOnSubmit class="o-grid">
    <div class="o-grid__row">
        @if (!isModal) {
            <div class="o-grid__item third stepper-min-width">
                <medpace-vertical-stepper [steps]="steps"></medpace-vertical-stepper>
            </div>
        }
        <div class="o-grid__item">
            <div class="o-grid">
                <div class="o-grid__row">
                    <div class="o-grid__card">
                        <div class="flex start middle">
                            <span class="required-asterisk">*</span>
                            <span class="note"> indicates a required field </span>
                        </div>
                    </div>
                    <ng-container *ngTemplateOutlet="createEditButton"></ng-container>
                </div>
                <div class="o-grid__row" id="siteInfo">
                    <div class="o-grid__card">
                        <medpace-input-card
                            title="Site Information"
                            type="site-info"
                            [showEditSaveButton]="isUpdate && isAssistantOrHigher"
                            [editMode]="!isUpdate"
                            [parentFormGroup]="siteFormGroup"
                            (incrementalUpdate)="submitIncrementalSave()"
                            (inputChangeEvent)="passAlongChange($event)"
                        >
                        </medpace-input-card>
                    </div>
                </div>
                <div class="o-grid__row">
                    <div class="o-grid__card" id="siteAddress">
                        <medpace-input-card
                            type="site-address"
                            title="Site Address"
                            [showEditSaveButton]="isUpdate && isAssistantOrHigher"
                            [editMode]="!isUpdate"
                            [parentFormGroup]="siteFormGroup"
                            (incrementalUpdate)="submitIncrementalSave()"
                            (inputChangeEvent)="passAlongChange($event)"
                            [isModal]="isModal"
                        >
                        </medpace-input-card>
                    </div>
                </div>
                <div class="o-grid__row">
                    <div class="o-grid__card" id="siteShippingAddress">
                        <medpace-input-card
                            type="site-shipping-address"
                            title="Site Shipping Address"
                            [showEditSaveButton]="isUpdate && isAssistantOrHigher"
                            [editMode]="!isUpdate"
                            [parentFormGroup]="siteFormGroup"
                            (incrementalUpdate)="submitIncrementalSave()"
                            (inputChangeEvent)="passAlongChange($event)"
                            [isModal]="isModal"
                        >
                        </medpace-input-card>
                    </div>
                </div>
                <div class="o-grid__row">
                    <div class="o-grid__card" id="siteServices">
                        <ng-content select="medpace-site-services" />
                    </div>
                </div>
                @if (isCrcCardVisible()) {
                    <div class="o-grid__row">
                        <div class="o-grid__card" id="siteCRCs">
                            @if (isUpdate) {
                                <medpace-crc-card2
                                    [vm]="crcCardVM_Edit$ | async"
                                    [mode]="'view'"
                                    [showSwitchModeButton]="isUpdate && isAssistantOrHigher"
                                ></medpace-crc-card2>
                            } @else {
                                <medpace-crc-card2
                                    [vm]="crcCardVM_Create$ | async"
                                    [mode]="'edit'"
                                    [showSwitchModeButton]="false"
                                ></medpace-crc-card2>
                            }
                        </div>
                    </div>
                }

                @if (isCrcInviteCardVisible()) {
                    <div class="o-grid__row">
                        <div class="o-grid__card" id="primaryCrc">
                            <medpace-input-card
                                type="site-crc-invite"
                                title="Primary CRC Invitation"
                                [editMode]="!isUpdate"
                                [parentFormGroup]="siteFormGroup"
                                [showEditSaveButton]="isUpdate && isAssistantOrHigher && !isEditButtonVisible()"
                                (incrementalUpdate)="submitIncrementalSave()"
                                (inputChangeEvent)="passAlongChange($event)"
                            >
                            </medpace-input-card>
                        </div>
                    </div>
                }
                @if (isAssistantOrHigher) {
                    <div class="o-grid__row">
                        <div class="o-grid__card" id="siteNote">
                            @if (isUpdate) {
                                <medpace-note-card
                                    [mode]="'view'"
                                    [title]="'Site Notes'"
                                    [showSwitchModeButton]="true"
                                    (saveEvent)="submitIncrementalSave()"
                                    [notes]="noteStore.siteNotes()"
                                    [context]="NoteCardContext.Site"
                                ></medpace-note-card>
                            } @else {
                                <medpace-note-card
                                    [mode]="'edit'"
                                    [title]="'Site Notes'"
                                    [showSwitchModeButton]="false"
                                    (saveEvent)="submitIncrementalSave()"
                                    [notes]="noteStore.siteNotes()"
                                    [context]="NoteCardContext.Site"
                                ></medpace-note-card>
                            }
                        </div>
                    </div>
                }

                <ng-container *ngTemplateOutlet="createEditButton"></ng-container>
            </div>
        </div>
    </div>
    @if (!isModal) {
        <div class="o-grid__row">
            <div class="o-grid__item u-ta-right">
                <span [ngClass]="isValidForm ? 'c-message' : 'c-message__show'">{{ validationMessage }}</span>
            </div>
        </div>
    }
</form>

<ng-template #createEditButton>
    @if (!isModal) {
        @if (!isUpdate) {
            <div class="o-grid__card">
                <div class="flex end">
                    <mds-button
                        id="createNewSiteBtn"
                        [color]="'primary'"
                        [variant]="'filled'"
                        label="Approve and submit"
                        (clickEvent)="submit()"
                        type="submit"
                    ></mds-button>
                </div>
            </div>
        }

        @if (isUpdate && isAssistantOrHigher) {
            <div class="o-grid__card">
                <div class="flex end gap-medpace">
                    @if ((hasPermissionToChangeStatus$ | async) && isChangeStatusButtonVisible()) {
                        <mds-button
                            id="changeStatusbtn"
                            color="primary"
                            [variant]="'tonal'"
                            label="Change status"
                            (clickEvent)="changeStatus()"
                        ></mds-button>
                    }
                    @if (hasPermissionToEditSite$ | async) {
                        <mds-button
                            id="update-site-btn"
                            [color]="'primary'"
                            [variant]="'filled'"
                            label="Update site"
                            (clickEvent)="submit()"
                            type="submit"
                        ></mds-button>
                    }
                </div>
            </div>
        }
    }
</ng-template>
